export default __webpack_public_path__ + "static/media/040-report.c86b7211.svg";